/// PROCURE POR 'BEST SAMPLE' ///

export class UserPermissions {
    constructor() {
        this.super = true
        this.scheduler = {
            show: true,
            scheduler: {
                write: true,
                finances: true,
            },
            configurations: {
                read: true,
                write: true,
            },
        }
        this.pos = {
            show: true,
            sales: {
                write: true,
                navigate: true,
                others: { read: true, write: false }, // por ora não tem opção de lançar por outros
                details: true,
                discount: 100,
            },
            quotes: {
                read: true,
                write: true,
            },
            taxInvoices: {
                read: true,
                write: true,
            },
        }
        this.customerService = {
            show: true,
            entries: {
                read: true,
                write: true,
                navigate: true,
            },
            configs: {
                read: true,
                write: true,
            },
        }
        this.comissions = {
            show: true,
            entries: { navigate: true, others: true, self: true },
            configs: { read: true, write: true },
        }
        this.dashboard = {
            show: true,
        }
        this.audience = {
            show: true,
            audience: {
                write: true,
            },
        }
        this.marketing = {
            show: true,
            marketing: {
                read: true,
                write: true,
            },
            audience: {
                read: true,
                write: true,
            },
            outbox: {
                read: true,
                write: true,
            },
            providers: {
                read: true,
                write: true,
            },
            templates: {
                read: true,
                write: true,
            },
        }
        // best sample
        this.partnership = {
            show: true,
            partners: {
                read: true,
                write: true,
                navigate: true,
            },
            entries: {
                read: true,
                write: true,
                navigate: true,
            },
            referrals: {
                read: true,
                write: true,
                navigate: true,
            },
        }
        //
        this.goals = {
            show: true,
            general: {
                read: true,
                write: true,
            },
            individual: {
                read: true,
                write: true,
            },
        }
        this.stock = {
            show: true,
            stock: {
                read: true,
                write: true,
            },
            inputs: {
                read: true,
                write: true,
            },
            outputs: {
                read: true,
                write: true,
            },
            configs: {
                read: true,
                write: true,
            },
        }
        //
        this.reports = {
            show: true,
            financials: true,
            persons: true,
            pos: true,
            schedules: true,
            // categorias do catálogo de relatórios (v2) que não tinham permissão
            nps: true,
            stock: true,
            pay: true,
        }
        //
        this.financial = {
            show: true,
            entries: {
                write: true,
                navigate: true,
            },
            reports: {
                navigate: true,
                read: true,
            },
            // abas do financeiro-4
            tabs: {
                home: true,
                billsToReceive: true,
                billsToPay: true,
                pos: true,
                accounts: true,
                reports: true,
            },
        }
        this.pay = {
            show: true,
            entries: {
                write: true,
                read: true,
                navigate: true,
            },
            links: {
                write: true,
                read: true,
            },
            gateways: {
                write: true,
                read: true,
            },
        }

        this.nps = {
            show: true,
            nps: {
                write: true,
            },
        }
        this.tags = {
            show: true,
            tags: {
                write: true,
            },
        }
        this.referral = {
            show: true,
            referral: {
                write: true,
            },
        }
        this.pipeline = {
            show: true,
            pipeline: {
                others: {
                    read: true,
                    write: true,
                },
            },
        }
        this.balance = {
            show: true,
        }
        this.tools = {
            show: true,
            forms: {
                read: true,
                write: true,
            },
            docs: {
                read: true,
                write: true,
            },
            services: {
                read: true,
                write: true,
            },
            payments: {
                read: true,
                write: true,
            },
            referrals: {
                read: true,
                write: true,
            },
            categories: {
                read: true,
                write: true,
            },
            accounts: {
                read: true,
                write: true,
            },
            providers: {
                read: true,
                write: true,
            },
            app: {
                read: true,
                write: true,
            },
            stock: {
                read: true,
                write: true,
            },
            scheduler: {
                read: true,
                write: true,
            },
            resources: {
                read: true,
                write: true,
            },
            goals: {
                read: true,
                write: true,
            },
            reports: {
                read: true,
                write: true,
            },
            quotation: {
                read: true,
                write: true,
            },
            customerService: {
                read: true,
                write: true,
            },
            payGateways: {
                read: true,
                write: true,
            },
            posTaxParams: {
                read: true,
                write: true,
            },
        }
        this.account = {
            users: {
                read: true,
                write: true,
            },
            devices: {
                read: true,
                write: true,
            },
            companies: {
                read: true,
                write: true,
            },
        }
        this.persons = {
            show: true,
            persons: {
                write: true,
            },
            tabs: {
                audience: true,
                events: true,
                forms: true,
                notes: true,
                pos: true,
                scheduler: true,
                prospect: true,
                balance: true,
                zanduPay: true,
                financial: true,
            },
        }
    }

    super: boolean
    scheduler: {
        show: boolean
        scheduler: {
            write: boolean
            finances: boolean
        }
        configurations: {
            read: boolean
            write: boolean
        }
    }
    pos: {
        show: boolean
        sales: {
            write: boolean
            navigate: boolean
            others: { read: boolean; write: boolean }
            details: boolean
            discount: number
        }
        quotes: {
            read: boolean
            write: boolean
        }
        taxInvoices: {
            read: boolean
            write: boolean
        }
    }
    customerService: {
        show: boolean
        entries: {
            read: boolean
            write: boolean
            navigate: boolean
        }
        configs: {
            read: boolean
            write: boolean
        }
    }
    dashboard: {
        show: boolean
    }
    audience: {
        show: boolean
        audience: {
            write: boolean
        }
    }
    marketing: {
        show: boolean
        marketing: {
            read: boolean
            write: boolean
        }
        audience: {
            read: boolean
            write: boolean
        }
        templates: {
            read: boolean
            write: boolean
        }
        providers: {
            read: boolean
            write: boolean
        }
        outbox: {
            read: boolean
            write: boolean
        }
    }
    comissions: {
        show: boolean
        entries: {
            self: boolean
            others: boolean
            navigate: boolean
        }
        configs: {
            read: boolean
            write: boolean
        }
    }
    financial: {
        show: boolean
        entries: {
            write: boolean
            navigate: boolean
        }
        reports: {
            read: boolean
            navigate: boolean
        }
        tabs: {
            home: boolean
            billsToReceive: boolean
            billsToPay: boolean
            pos: boolean
            accounts: boolean
            reports: boolean
        }
    }
    // best sample
    partnership: {
        show: boolean
        partners: {
            read: boolean
            write: boolean
            navigate: boolean
        }
        referrals: {
            read: boolean
            write: boolean
            navigate: boolean
        }
        entries: {
            read: boolean
            write: boolean
            navigate: boolean
        }
    }
    //
    goals: {
        show: boolean
        general: {
            write: boolean
            read: boolean
        }
        individual: {
            write: boolean
            read: boolean
        }
    }
    stock: {
        show: boolean
        stock: {
            write: boolean
            read: boolean
        }
        inputs: {
            write: boolean
            read: boolean
        }
        outputs: {
            write: boolean
            read: boolean
        }
        configs: {
            read: boolean
            write: boolean
        }
    }
    reports: {
        show: boolean
        schedules: boolean
        financials: boolean
        pos: boolean
        persons: boolean
        nps: boolean
        stock: boolean
        pay: boolean
    }
    ///
    pay: {
        show: boolean
        entries: {
            write: boolean
            read: boolean
            navigate: boolean
        }
        links: {
            write: boolean
            read: boolean
        }
        gateways: {
            write: boolean
            read: boolean
        }
    }
    nps: {
        show: boolean
        nps: {
            write: boolean
        }
    }
    tags: {
        show: boolean
        tags: {
            write: boolean
        }
    }
    referral: {
        show: boolean
        referral: {
            write: boolean
        }
    }
    pipeline: {
        show: boolean
        pipeline: {
            others: {
                read: boolean
                write: boolean
            }
        }
    }
    balance: {
        show: boolean
    }
    tools: {
        show: boolean
        forms: {
            read: boolean
            write: boolean
        }
        docs: {
            read: boolean
            write: boolean
        }
        services: {
            read: boolean
            write: boolean
        }
        payments: {
            read: boolean
            write: boolean
        }
        referrals: {
            read: boolean
            write: boolean
        }
        categories: {
            read: boolean
            write: boolean
        }
        accounts: {
            read: boolean
            write: boolean
        }
        providers: {
            read: boolean
            write: boolean
        }
        app: {
            read: boolean
            write: boolean
        }
        stock: {
            read: boolean
            write: boolean
        }
        scheduler: {
            read: boolean
            write: boolean
        }
        resources: {
            read: boolean
            write: boolean
        }
        goals: {
            read: boolean
            write: boolean
        }
        reports: {
            read: boolean
            write: boolean
        }
        customerService: {
            read: boolean
            write: boolean
        }
        quotation: {
            read: boolean
            write: boolean
        }
        payGateways: {
            read: boolean
            write: boolean
        }
        posTaxParams: {
            read: boolean
            write: boolean
        }
    }
    account: {
        users: {
            read: boolean
            write: boolean
        }
        devices: {
            read: boolean
            write: boolean
        }
        companies: {
            read: boolean
            write: boolean
        }
    }
    persons: {
        show: boolean
        persons: {
            write: boolean
        }
        tabs: {
            notes: boolean
            forms: boolean
            pos: boolean
            scheduler: boolean
            audience: boolean
            events: boolean
            prospect: boolean
            balance: boolean
            zanduPay: boolean
            financial: boolean
        }
    }
}
